export const PLATFORM_OPTIONS = [
  { label: 'iOS', value: 'IOS' },
  { label: 'Android', value: 'Android' },
]

export function getPlatformLabel(system) {
  const value = String(system || '').trim()
  if (value === 'IOS') return 'iOS'
  if (value === 'Android') return 'Android'
  return value || '—'
}

/** 平台 pill tone：iOS / Android 固定色，便于列表扫读。 */
export function getPlatformVariant(system) {
  const value = String(system || '').trim()
  if (value === 'IOS') return 'sky'
  if (value === 'Android') return 'teal'
  return 'neutral'
}

export function getPictureFormatLabel(pictureFormat) {
  return String(pictureFormat) === '2' ? 'WebP' : '通用格式'
}

export function formatPackagePreview(packageList, maxVisible = 2) {
  const items = (packageList || []).filter((item) => String(item || '').trim())
  if (!items.length) return '—'
  if (items.length <= maxVisible) return items.join(' · ')
  return `${items.slice(0, maxVisible).join(' · ')} 等 ${items.length} 个`
}
